<template>
  <div>
    <!-- {{ projects }}
    {{ issuesGrouped }} -->
    <b-list-group class="project-list">
      <b-list-group-item v-for="p in projectsWithStats" :key="p.id"
        class="d-xl-flex justify-content-between align-items-center py-1 px-2">
        <!-- <span :style="`color:${percentColorGroup(issuesGrouped[p.external_id].score).color};`">{{ p.name }}</span> -->
        <b-link :style="`color:${percentColorGroup(issuesGrouped[p.external_id]?.score).color};`"
          :to="{ name: 'ProjectHome', params: { jira_key: p.key } }">
          {{ p.name }}
        </b-link>
        <!-- <span v-if="issuesGrouped[p.external_id]">
          <b-badge variant="primary" pill v-for="(stats, idx) in issuesGrouped[p.external_id].groups"
            :key="`${p.id}.${idx}`">
            {{ issuesSizeDefs[idx].name }} | {{ Math.round(stats.timePercent * 100) }}% | {{ stats.timespent }}|
            {{ stats.count }}
          </b-badge>
        </span> -->
        <span class="d-xl-flex justify-content-between align-items-center percent-data">
          <b-badge v-if="issuesGrouped[p.external_id]"
            :style="`min-width:45px; color:${percentColorGroup(issuesGrouped[p.external_id].score).color};border-color:${percentColorGroup(issuesGrouped[p.external_id].score).color};`"
            class="mx-2 percent-badge">
            {{ issuesGrouped[p.external_id].score }}%
          </b-badge>
          <div class="progress" v-if="issuesGrouped[p.external_id]">
            <div class="progress-bar" v-for="(stats, idx) in issuesGrouped[p.external_id].groups" :key="`${p.id}.${idx}`"
              role="progressbar" aria-valuemin="0" aria-valuemax="100"
              :style="`width: ${Math.round(stats.timePercent * 100)}%;background-color:${issuesSizeDefs[idx].color}`"
              :aria-valuenow="Math.round(stats.timePercent * 100)" @click="debugIssues(stats)">
              {{ Math.round(stats.timePercent * 100) }}%
            </div>
          </div>
        </span>
      </b-list-group-item>
    </b-list-group>
    <div v-if="issuesDebug.length">
      <b-link v-for="i in issuesDebug" :key="i.jira_key" :href="'https://applyit.atlassian.net/browse/' + i.jira_key">
        <b-badge variant="primary" pill>
          {{ i.jira_key }} | {{ Math.round(i.timespent / 60) }}h
        </b-badge>
      </b-link>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Services from '@/services';

export default {
  mounted() {
    this.getData();
  },
  props: {},
  data() {
    return {
      loading: true,
      issues: [],
      projects: [],
      issuesDebug: [],
      issuesSizeDefs: [
        {
          order: 0,
          score: 1.0,
          color: '#a6a6a6',
          name: this.$dt('issue_size_def.tiny', 'Tiny'),
          from: null,
          to: 60 // minutes
        },
        {
          order: 1,
          score: 1.0,
          color: '#5a9943',
          name: this.$dt('issue_size_def.small', 'Normal'),
          from: 60,
          to: 60 * 8 * 2 // minutes
        },
        {
          order: 2,
          score: 0.9,
          color: '#a8ad45',
          name: this.$dt('issue_size_def.large', 'Large'),
          from: 60 * 8 * 2,
          to: 60 * 8 * 5 // minutes
        },
        {
          order: 3,
          score: 0.5,
          color: '#db7202',
          name: this.$dt('issue_size_def.elarge', 'Extra large'),
          from: 60 * 8 * 5,
          to: 60 * 8 * 10 // minutes
        },
        {
          order: 4,
          score: 0.0,
          color: '#db1402',
          name: this.$dt('issue_size_def.too_large', 'Too large'),
          from: 60 * 8 * 10,
          to: null // minutes
        },
      ],
      percentColorDefs: [
        {
          color: '#db1402',
          name: this.$dt('issue_percent_def.critical', 'Critical'),
          from: null,
          to: 25
        },
        {
          color: '#db7202',
          name: this.$dt('issue_percent_def.bad', 'Bad'),
          from: 25,
          to: 50
        },
        {
          color: '#a8ad45',
          name: this.$dt('issue_percent_def.reasonable', 'Reasonable'),
          from: 50,
          to: 85
        },
        {
          color: '#5a9943',
          name: this.$dt('issue_percent_def.excellent', 'Excellent'),
          from: 85,
          to: null
        },
      ]
      // userIssuesVerbose: [],
    };
  },
  computed: {
    projectsWithStats() {
      const projects = this.projects.map((p) => {
        p.stats = this.issuesGrouped[p.external_id] || { score: 0 };
        return p;
      });
      projects.sort((a, b) => { return -1 * ((a.stats.score < b.stats.score) ? -1 : (a.stats.score > b.stats.score) ? 1 : 0); });
      return projects;
    },
    issuesGrouped() {
      const istats = this.issues.reduce((stats, i) => {
        if (!stats[i.jira_project_id]) {
          stats[i.jira_project_id] = {
            timespent: 0,
            count: 0,
            scoreTotal: 0.0,
            avgIssueLength: 0.0,
            groups: this.issuesSizeDefs.map((sd) => { return { issues: [], def: sd, timespent: 0, count: 0 }; })
          };
        }
        const { defIdx, def } = this.timeLogGroup(i.timespent);
        if (defIdx !== null) {
          stats[i.jira_project_id].groups[defIdx].timespent += i.timespent;
          stats[i.jira_project_id].groups[defIdx].count += 1;
          stats[i.jira_project_id].groups[defIdx].issues.push(i);
        }

        stats[i.jira_project_id].timespent += i.timespent;
        stats[i.jira_project_id].count += 1;

        return stats;
      }, {});
      return Object.keys(istats).reduce((stats, pid) => {
        stats[pid] = istats[pid];
        stats[pid].groups = stats[pid].groups.map((g) => {
          return {
            ...g,
            timePercent: g.timespent / stats[pid].timespent
          };
        });
        const avgIssueLength = stats[pid].timespent / stats[pid].count;
        stats[pid].avgIssueLength = avgIssueLength;
        stats[pid].groups.forEach((g) => g.issues.forEach((i) => {
          stats[pid].scoreTotal += g.def.score * ((i.timespent / avgIssueLength) / stats[pid].count);
          // stats[pid].cntTest += ((i.timespent / avgIssueLength) / stats[pid].count);
        }));
        stats[pid].score = Math.round(stats[pid].scoreTotal * 1000) / 10.0;
        return stats;
      }, {});
    }
  },
  methods: {
    getData() {
      this.loading = true;
      Promise.all([
        Services.dash.ProjectIssueForTimeStats([]),
      ]).then(([userIssuesResp]) => {
        this.issues = userIssuesResp.data.issues.map((i) => {
          return {
            jira_project_id: i.jira_project_id,
            timespent: i.timespent * 1,
            jira_key: i.jira_key
          };
        });
        this.projects = userIssuesResp.data.projects;
        this.loading = false;
      });
    },
    timeLogGroup(time) {
      const defIdx = this.issuesSizeDefs.findIndex((d) => {
        return (d.from === null || d.from <= time) && (d.to === null || d.to > time);
      });
      return { defIdx, def: (defIdx !== null) ? this.issuesSizeDefs[defIdx] : null };
    },

    percentColorGroup(percent) {
      const def = this.percentColorDefs.find((d) => {
        return (d.from === null || d.from <= percent) && (d.to === null || d.to > percent);
      });
      return def || { color: '#a6a6a6', name: this.$dt('issue_percent_def.notfound', 'NotFound') };
    },

    debugIssues(stats) {
      console.log(stats);
      this.issuesDebug = stats.issues;
    },
  }
};

// };
</script>
<style lang=scss>
.project-list,
.project-list .list-group-item {
  border-color: $gray;
}

.badge.percent-badge {
  background-color: $white;
  border: solid 1px $gray;
}
</style>

<style scoped lang=scss>
@media(max-width: map-get($grid-breakpoints, xl)) {
  .percent-data .percent-badge {
    float: right;
    display: block;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }
}

@media(min-width: map-get($grid-breakpoints, xl)) {
  div.progress {
    width: 300px;
  }
}
</style>
